import React from 'react'

const Footer = () => {
    return (
        <>
            <footer class="fix">
        <div class="tp-footer-2__area tp-footer-2__bg pt-120">
            <div class="container">
                {/* <div class="tp-footer-2__border p-relative"> 
                    <div class="tp-footer-2__shape-1 d-none d-xxl-block">
                        <img src="assets/img/footer/shape-2-1.png" alt="" />
                    </div>
                    <div class="row">
                        <div class="col-xl-8 col-lg-7 col-md-6">
                            <div class="tp-footer-2__top-box">
                                <h4 class="tp-footer-2__top-title">We look forward to <br></br>
                                    hearing from you.</h4>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-6">
                            <div class="tp-footer-2__form">
                                <form action="#">
                                    <input type="email" placeholder="Enter your e-mail"/>
                                </form>
                                <span class="tp-footer-2__input-icon">
                                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17 7.4C17 10.417 17 11.9255 16.0627 12.8627C15.1255 13.8 13.617 13.8 10.6 13.8H7.4C4.38301 13.8 2.87452 13.8 1.93726 12.8627C1 11.9255 1 10.417 1 7.4C1 4.38301 1 2.87452 1.93726 1.93726C2.87452 1 4.38301 1 7.4 1H10.6C13.617 1 15.1255 1 16.0627 1.93726C16.5853 2.4598 16.8165 3.15991 16.9188 4.2"
                                            stroke="#82868C" stroke-width="1.5" stroke-linecap="round" />
                                        <path
                                            d="M13.7995 4.19922L12.0723 5.63848C10.603 6.86291 9.86838 7.47512 8.99946 7.47512C8.48002 7.47512 8.00857 7.25634 7.39946 6.81877M4.19946 4.19922L4.91946 4.79922L5.63946 5.39922"
                                            stroke="#82868C" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
    
                                </span>
                                <button class="tp-btn-sm">
                                    subscribe us
                                </button>
                            </div>
                      </div>
                   </div>
                </div> */}
                <div class="tp-footer-2__ptb">
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
                            <div class="tp-footer-2__widget footer-col-5">
                                <div class="tp-footer-2__logo">
                                   {/* <a href="index-2.html"><img src="assets/img/logo/white-logo.png" alt="" /></a> */}
                                   <h2>AN Educare</h2>
                                </div>
                                <div class="tp-footer-2__text">
                                    <p>OPPOSITE TO CPS, NEW BUILDING, AZAD CHOWK, TAJPUR ROAD, SAMASTIPUR</p>
                                </div>
                                <div class="tp-footer-2__contact-list">
                                    <a href="https://template.wphix.com/cdn-cgi/l/email-protection#6f1c1a1f1f001d1b2f0a170e021f030a410c0002"><span class="__cf_email__">info.aneducare@gmail.com</span></a>
                                    <a href="tel:+406555-0120">9430535356, 9431400242</a>
                                </div>
                                <div class="tp-footer-2__social-box">
                                    <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
                                    <a href="#"><i class="fa-brands fa-vimeo-v"></i></a>
                                    <a href="#"><i class="fa-brands fa-twitter"></i></a>
                                    <a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".5s">
                            <div class="tp-footer-2__widget footer-col-6">
                                <h4 class="tp-footer-2__widget-title">Our Courses</h4>
                                <div class="tp-footer-2__list">
                                    <ul>
                                        <li><a href="#">-</a></li>
                                        <li><a href="#">-</a></li>
                                        <li><a href="#">-</a></li>
                                        <li><a href="#">-</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".7s">
                            <div class="tp-footer-2__widget footer-col-7">
                                <h4 class="tp-footer-2__widget-title">Pages</h4>
                                <div class="tp-footer-2__list">
                                    <ul>
                                        <li><a href="#">-</a></li>
                                        <li><a href="#">-</a></li>
                                        <li><a href="#">-</a></li>
                                        <li><a href="#">-</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
           </div>
        </div>

        






    </footer>






















    <div class="tp-copyright-2__area black-bg-2">
            <div class="container">
                <div class="tp-copyright-2__bdr">
                    <div class="row align-items-center">
                        <div class="col-xl-6 col-lg-6 col-md-6  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
                            <div class="tp-copyright-2__text text-center text-md-start">
                                <span>Developed By - <a href="https://www.hashedbit.com/" target='_blank'>HashedBit Innovations</a></span>
                            </div>
                        </div>
                        {/* <div class="col-xl-6 col-lg-6 col-md-6  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
                            <div class="tp-copyright-2__thumb text-end d-none d-md-block">
                               <a href="#"><img src="assets/img/footer/footer-2-1.png" alt=""/></a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>








        </>
    )
}

export default Footer
